<div fxLayout="row" class="container" fxFlex="100" fxLayoutAlign="space-between" [formGroup]="formGroup">
  <!-- First column -->
  <div class="column" fxLayout="column" fxFlex="32">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'FirstName' | translate }}</mat-label>
      <input matInput type="text" formControlName="firstName" />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>{{ 'Company' | translate }}</mat-label>
      <input
        matInput
        formControlName="company"
        placeholder="{{ 'Company' | translate }}"
        [matAutocomplete]="autocompleteEmployerObject"
        [errorStateMatcher]="matcher"
        />
        <mat-autocomplete #autocompleteEmployerObject="matAutocomplete" [displayWith]="displayValue">
          @for (company of companies$ | async; track company) {
            <mat-option [value]="company">
              {{ company.Name }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </div>

    <!-- Second column -->
    <div class="column" fxLayout="column" fxFlex="32">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'LastName' | translate }}</mat-label>
        <input matInput type="text" formControlName="lastName" />
      </mat-form-field>
    </div>

    <!-- Third column -->
    <div class="column" fxLayout="column" fxFlex="32">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'Pesel' | translate }}</mat-label>
        <input matInput type="text" formControlName="pesel" />
      </mat-form-field>

      <div>
        <ng-content></ng-content>
      </div>
    </div>
  </div>
